export enum routePaths {
  DASHBOARD = "dashboard",
  EDIT = "edit",
  USERS = "users",
  CREDITS = "credits",
  ZENDESK = "zendesk",
  HINTS = "hints",
  EVENTS = "events",
  PROFILE = "profile",
  ACTIVE_EVENTS = "events/active",
  ARCHIVED_EVENTS = "events/archived",
  BADGE_DESIGNER = "badgedesign",
  BADGE_TEMPLATES = "badgetemplates",
  NEW_EVENT = "events/new",
  CREATE_EVENT = "create-event",
  ATTENDEES = "attendees",
  SESSIONS = "sessions",
  NEW_ATTENDEE = "attendees/new",
  NEW_SESSION = "sessions/new",
  ACCOUNTS = "accounts",
  PASSWORD_FORGOT = "forgotPassword",
  PASSWORD_CHANGE = "change-password",
  LOGIN = "login",
  RESERVATIONS = "reservations",
  DEVELOPER_API_DOCS = "devApi",
  SYSADMIN_API_DOCS = "sysadminApi",
  BADGE_SIZES = "badgesizes",
  VERSION_HISTORY = "version",
  ALERT = "Alert",
  SCANNED_IN_ATTENDEE = "scanned-in",
  MICROSITE = "microsite",
  ANALYTICS = "analytics",
  EXHIBITOR = "exhibitor",
  NEW_EXHIBITOR = "exhibitor/new",
  LEAD_RETRIEVAL_SETTINGS = "lead-retrieval/settings",
  LOG_PROCESS = "log-process",
  ANALYTICS_DASHBOARD = "analytics",
  KIOSK_CENTER = "kiosk-center",
}
